<template>
  <div
    :id="data.Id"
    :data-elementindex="getElementIndex"
    :style="getShapeStyles"
    :data-translateX="data.X"
    :data-translateY="data.Y"
    :data-rotate="data.RotateDegree"
    :class="['target ']"
    class="position-absolute d-flex object-add"
    data-type="shape">
    <div :style="getFlipWrapperStyle">
    <svg
      v-if="getShapeType === 'rectangle'"
      :viewBox="data.isNewObject? '': getShapeViewBox"
      :width="data.Width"
      :height="data.Height"
      :style="getSvgStyle"
      xmlns="http://www.w3.org/2000/svg">
      <linearGradient
        v-if="data.isGradient"
        :id="`gradient-${data.Id}-${uniqueId}`"
        :gradientTransform="`rotate(${data.gradient.angle})`">
        <stop
          v-for="(color, index) of sortedColors"
          :key="index"
          :offset="`${color.position}%`"
          :stop-color="`${color.rgba}`"/>
      </linearGradient>
      <rect
        :width="data.Width"
        :height="data.Height"
        :style="getRectStyle"/>

    </svg>
    <svg
      v-if="getShapeType === 'ellipses'"
      :viewBox="data.isNewObject ? null: getShapeViewBox"
      :width="getEllipseWidth"
      :height="getEllipseHeight"
      :style="getSvgStyle"
      xmlns="http://www.w3.org/2000/svg">
      <linearGradient
        v-if="data.isGradient"
        :id="`gradient-${data.Id}-${uniqueId}`"
        :gradientTransform="`rotate(${data.gradient.angle})`">
        <stop
          v-for="(color, index) of sortedColors"
          :key="index"
          :offset="`${color.position}%`"
          :stop-color="`${color.rgba}`"/>
      </linearGradient>
      <ellipse
        :cx="data.CurveCenterX"
        :cy="data.CurveCenterY"
        :rx="data.CurveHorizontalRadius"
        :ry="data.CurveVerticalRadius"
        :style="getEllipseStyle"/>
    </svg>
    <svg
      v-else-if="getShapeType === 'polygon'"
      ref="polygon-parent"
      :viewBox="getShapeViewBox"
      :width="data.polygonWidth"
      :height="data.polygonHeight"
      :style="getSvgStyle"
      xmlns="http://www.w3.org/2000/svg">
      <linearGradient
        v-if="data.isGradient"
        :id="`gradient-${data.Id}-${uniqueId}`"
        :gradientTransform="`rotate(${data.gradient.angle})`">
        <stop
          v-for="(color, index) of sortedColors"
          :key="index"
          :offset="`${color.position}%`"
          :stop-color="`${color.rgba}`"/>
      </linearGradient>
      <polygon
        ref="polygonRef"
        :points="data.PolygonPoints"
        :style="getPolygonStyle"/>
      />
    </svg>
    <div
      v-else-if="getShapeType === 'svgShapes'"
      v-html="data.svgContent"/>
    </div>
  </div>
</template>
<script>
import { uuid } from 'vue-uuid';
import { updateEllipse } from '@/components/Canvas/utils/groupHelpers';

export default {
  name:       'ObjectShape',
  components: {},
  props:      {
    data:         Object,
    elementIndex: Number,
    objectProps:  {
      type:    Object,
      default: {},
    },
    isGroupChild: { type: Boolean, default: false },
  },
  data() {
    return {
      bbox:     {},
      uniqueId: '',
    };
  },
  computed: {
    sortedColors() {
      return this.data.gradient.colors.slice().sort((a, b) => a.position - b.position);
    },
    isHFlipped() {
      const value = this.data.IsHFlipped != null ? this.data.IsHFlipped : this.objectProps.IsHFlipped;
      try {
        return JSON.parse(value);
      } catch (e) {
        return !!value;
      }
    },
    isVFlipped() {
      const value = this.data.IsVFlipped != null ? this.data.IsVFlipped : this.objectProps.IsVFlipped;
      try {
        return JSON.parse(value);
      } catch (e) {
        return !!value;
      }
    },
    locked:     ({ objectProps }) => objectProps.locked,
    getShapeViewBox() {
      const strokeWidth      = (this.data.StrokeWidth) ? this.data.StrokeWidth : 0;
      const strokeAdjustment = strokeWidth > 0 ? strokeWidth / 2 : 0;
      if (this.getShapeType === 'ellipses') {
        const x1 = this.data.CurveCenterX - this.data.CurveHorizontalRadius;
        const y1 = this.data.CurveCenterY - this.data.CurveVerticalRadius;

        return `${x1 - strokeAdjustment} ${y1 - strokeAdjustment} ${this.getEllipseWidth + strokeWidth} ${this.getEllipseHeight + strokeWidth}`;
      }
      if (this.getShapeType === 'polygon') {
        // console.log('bbox is ', this.bbox);
        // const calculatedBbox = this.getBBoxCustom(this.$refs.polygonRef);
        // const bbox           = calculatedBbox;
        return `${(this.data.initialX - strokeAdjustment)} ${(this.data.initialY - strokeAdjustment)} ${this.data.polygonWidth + strokeWidth} ${this.data.polygonHeight + strokeWidth}`;
      }
      if (this.getShapeType === 'rectangle') {
        return `${this.data.initialX} ${this.data.initialY} ${this.data.Width} ${this.data.Height}`;
      }
    },
    getRectStyle() {
      const style = {
        fill:        this.data.isGradient ? `url(#gradient-${this.data.Id}-${this.uniqueId})` : this.data.DefaultColor,
        stroke:      this.data.StrokeColor,
        strokeWidth: `${this.data.StrokeWidth}px`,
      };
      return style;
    },
    getEllipseStyle() {
      const style = {
        fill:        this.data.isGradient ? `url(#gradient-${this.data.Id}-${this.uniqueId})` : this.data.DefaultColor,
        stroke:      this.data.StrokeColor,
        strokeWidth: `${this.data.StrokeWidth}px`,
      };
      return style;
    },
    getPolygonStyle() {
      const style = { fill: this.data.isGradient ? `url(#gradient-${this.data.Id}-${this.uniqueId})` : this.data.DefaultColor, stroke: this.data.StrokeColor, strokeWidth: `${this.data.StrokeWidth}px` };
      return style;
    },
    getFlipWrapperStyle() {
      const flipX = this.isHFlipped ? -1 : 1;
      const flipY = this.isVFlipped ? -1 : 1;
      return {
        width:           '100%',
        height:          '100%',
        display:         'flex',
        alignItems:      'baseline',
        transform:       `scale(${flipX}, ${flipY})`,
        transformOrigin: 'center center',
      };
    },
    getSvgStyle() {
      let scaleX = this.data.svgScaleX || 1;
      let scaleY = this.data.svgScaleY || 1;
      if (this.getShapeType === 'rectangle') {
        scaleX = 1;
        scaleY = 1;
      }
      return {
        transform:       `scale(${scaleX}, ${scaleY})`,
        transformOrigin: 'left top',
        verticalAlign:   this.getShapeType === 'polygon' ? 'top' : 'middle',
        overflow:        'visible',
      };
    },
    getElementIndex() {
      if (this.isGroupChild) {
        return typeof this.elementIndex === 'number' ? this.elementIndex : -1;
      }
      return this.data.elementIndex;
    },
    getHorizontalFlip() {
      return this.data.isHFlipped === true ? -1 : 1;
    },
    getVerticalFlip() {
      return this.data.isVFlipped === true ? -1 : 1;
    },

    getShapeType() {
      return this.data.shapeType;
    },
    getShapeStyles() {
      const {
        X, Y, RotateDegree, scaleX, scaleY, DefaultColor, Width, Height, Alpha, shadow, effect,
      } = this.data;
      const isShadow      = effect && (effect === 'shadow');
      let filter          = 'none';
      const pointerEvents = (this.locked) ? 'none' : 'all';
      if (isShadow) {
        const initialDistance = 0.04; // Default distance for shadow effect
        const initailAngle    = 45; // Default angle for shadow effect
        const initailBlur     = 0.1; // Default blur for shadow effect
        const scaledDistance  = (isShadow && shadow && typeof shadow.distance != 'undefined' ? parseFloat(shadow.distance) : initialDistance) * Math.max(this.objectProps.Height, this.objectProps.Width);
        const radians         = ((isShadow && shadow && shadow.angle ? shadow.angle : initailAngle) * Math.PI) / 180;
        const shadowOffsetX   = scaledDistance * Math.cos(radians);
        const shadowOffsetY   = scaledDistance * Math.sin(radians);
        filter                = `drop-shadow(${shadowOffsetX}px ${shadowOffsetY}px ${(isShadow && shadow && (typeof shadow.blur !== 'undefined') ? shadow.blur : initailBlur) * 40}px ${isShadow && shadow && shadow.color ? shadow.color : '#846C63'})`;
      }

      return {
        transform:  `rotate(${RotateDegree}deg) scale(${scaleX}, ${scaleY})`,
        transformOrigin: 'center center',
        // backgroundColor: this.getShapeType === 'rectangle' ? DefaultColor : '',
        height:     Height !== 0 ? `${Height}px` : 'auto',
        width:      Width !== 0 ? `${Width}px` : 'auto',
        zIndex:     this.data.PdfSortOrder,
        display:    this.data.IsVisible ? 'flex !important' : 'none !important',
        alignItems: 'baseline',
        opacity:    parseFloat(Alpha) / 100,
        top:        `${Y}px`,
        left:       `${X}px`,
        filter,
        pointerEvents,

      };
    },
    getLocked() {
      return this.data.locked;
    },
    getEllipseWidth() {
      return this.data.CurveHorizontalRadius * 2;
    },
    getEllipseHeight() {
      return this.data.CurveVerticalRadius * 2;
    },
  },
  mounted() {
    this.uniqueId = uuid.v1();
    this.updateEllipseTransform();
    if (this.$refs.polygonRef && this.$refs.polygonRef.getBBox().width > 0) { this.getBBoxCustom(this.$refs.polygonRef).then((response) => { this.bbox = response; }); }
  },
  watch: {
    'data.StrokeColor'(color) {
      if (!color || !this.$el) { return; }
      this.$el.querySelectorAll('line, path, rect, ellipse, polygon').forEach((el) => {
        el.style.stroke = color;
        el.setAttribute('stroke', color);
      });
    },
  },
  updated() {
    this.$nextTick(() => {
      if (this.$refs.polygonRef && this.$refs.polygonRef.getBBox().width > 0) {
        this.getBBoxCustom(this.$refs.polygonRef).then((response) => {
          this.$refs['polygon-parent'].setAttribute('viewBox', `${response.x} ${response.y} ${response.width} ${response.height}`);
        });
      }
    });
  },
  methods: {
    updateEllipseTransform() {
      if (!(this.data && this.data.type === 'shape' && this.data.shapeType === 'ellipses')) {
        return;
      }
      const svg = this.$el && this.$el.querySelector('svg');
      if (!svg) {
        return;
      }
      const svgWidth  = parseFloat(svg.getAttribute('width'));
      const svgHeight = parseFloat(svg.getAttribute('height'));
      const boxWidth  = parseFloat(this.data.Width);
      const boxHeight = parseFloat(this.data.Height);
      if (!(svgWidth > 0 && svgHeight > 0 && boxWidth > 0 && boxHeight > 0)) {
        return;
      }
      if (Math.abs(boxWidth - svgWidth) > 0.5 || Math.abs(boxHeight - svgHeight) > 0.5) {
        updateEllipse(this.data);
        return;
      }
      this.data.svgScaleX = boxWidth / svgWidth;
      this.data.svgScaleY = boxHeight / svgHeight;
    },
    async getBBoxCustom(el) {
      if (!el) {
        console.log('getBBoxCustom: no element provided');
        return;
      }
      let bb   = el.getBBox();
      const ns = 'http://www.w3.org/2000/svg';

      /**
       * check element type
       * stroke properties and transformations
       */
      const type             = el.nodeName;
      const parent           = el.farthestViewportElement;
      const {
        a,
        b,
        c,
        d,
        e,
        f,
      } = parent.getScreenCTM().inverse().multiply(el.getScreenCTM());
      const matrixStr        = [a, b, c, d, e, f].map(val => +val.toFixed(3)).join(' ');
      const hasTransforms    = matrixStr !== '1 0 0 1 0 0';
      const style            = window.getComputedStyle(el);
      const hasStroke        = !!(style.strokeWidth && style.stroke);
      const hasStrokeLinecap = !!(hasStroke && style.strokeLinecap !== 'butt');
      const strokeWidth      = parseFloat(style.strokeWidth);


      /**
       * no stroke - no transforms:
       * return standard bBox
       */
      if (!hasStroke && hasTransforms) {
        console.log('standard bbox');
        return bb;
      }

      /**
       * no transforms and straight angles:
       * return standard bBox + stroke widths
       */
      if (
        (type === 'rect' || type === 'line')
          && !hasTransforms
      ) {
        if (type === 'line') {
          const isVertical   = +el.getAttribute('x1') === +el.getAttribute('x2');
          const isHorizontal = +el.getAttribute('y1') === +el.getAttribute('y2');

          if (hasStrokeLinecap || isHorizontal) {
            bb.y      -= strokeWidth / 2;
            bb.height += strokeWidth;
          }

          if (hasStrokeLinecap || isVertical) {
            bb.x     -= strokeWidth / 2;
            bb.width += strokeWidth;
          }
          return bb;
        }

        if (type === 'rect') {
          bb.x      -= strokeWidth / 2;
          bb.width  += strokeWidth;
          bb.y      -= strokeWidth / 2;
          bb.height += strokeWidth;
          return bb;
        }
      }

      if (type === 'polygon') {
        bb.x      -= strokeWidth / 2;
        bb.width  += strokeWidth;
        bb.y      -= strokeWidth / 2;
        bb.height += strokeWidth;
        return bb;
      }

      const canvas = document.createElement('canvas');
      const ctx    = canvas.getContext('2d');


      // create temporary svg
      const svgTmp   = document.createElementNS(ns, 'svg');
      const elCloned = el.cloneNode(true);
      document.body.append(svgTmp);
      // document.body.append(canvas)

      // if transformed - wrap in group recalculate bbox
      if (hasTransforms) {
        const g = document.createElementNS(ns, 'g');
        g.append(elCloned);
        svgTmp.append(g);

        // update bbox
        bb = g.getBBox();
      } else {
        svgTmp.append(elCloned);
      }


      // crop viewBox to element to reduce pixel checks
      const strokeOffset = strokeWidth * 10;
      const {
        x,
        y,
        width,
        height,
      } = bb;


      const viewBoxNew = [
        Math.ceil(x - strokeOffset / 2),
        Math.ceil(y - strokeOffset / 2),
        Math.ceil(width + strokeOffset),
        Math.ceil(height + strokeOffset),
      ];

      svgTmp.setAttribute('viewBox', viewBoxNew.join(' '));
      const w = viewBoxNew[2];
      const h = viewBoxNew[3];

      /**
       * set height and width for Firefox
       */
      svgTmp.setAttribute('width', w);
      svgTmp.setAttribute('height', h);
      const svgURL = await new XMLSerializer().serializeToString(svgTmp);


      // draw to canvas
      canvas.width  = w;
      canvas.height = h;
      const img     = new Image();
      img.src       = `data:image/svg+xml; charset=utf8, ${encodeURIComponent(svgURL)}`;
      await img.decode();
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      /**
       * get bbox from
       * opaque pixels
       */
      const data   = ctx.getImageData(0, 0, w, h).data;
      let currentX = 0;
      let currentY = 0;

      let xMin = x + w;
      let xMax = 0;
      let yMin = y + h;
      let yMax = 0;


      /**
       * loop through color array
       * every 4. item is new pixel
       */
      for (let i = 0; i < data.length; i += 4) {
        // separate array chunk into rgba values
        const [r, g, b, a] = [data[i], data[i + 1], data[i + 2], data[i + 3]];
        if (a > 0) {
          xMin = currentX < xMin ? currentX : xMin;
          xMax = currentX > xMax ? currentX : xMax;
          yMin = currentY < yMin ? currentY : yMin;
          yMax = currentY > yMax ? currentY : yMax;
        }

        // is new "pixel row" – increment y value, reset x to "0"
        if (currentX + 1 >= w) {
          currentX = 0;
          currentY++;
        } else {
          currentX++;
        }
      }


      // recalculate viewBox according to previous offset
      const bboxCanvas = {
        x:      xMin + viewBoxNew[0],
        y:      yMin + viewBoxNew[1],
        width:  xMax - xMin + 1,
        height: yMax - yMin + 1,
      };

      // remove tmp svg
      svgTmp.remove();
      return bboxCanvas;
    },
    // getPolygonBBox(points) {
    //   const xs   = points.map(p => p[0]);
    //   const ys   = points.map(p => p[1]);
    //   const minX = Math.min(...xs);
    //   const minY = Math.min(...ys);
    //   const maxX = Math.max(...xs);
    //   const maxY = Math.max(...ys);
    //   return {
    //     x:      minX,
    //     y:      minY,
    //     width:  maxX - minX,
    //     height: maxY - minY,
    //   };
    // },
  },
};

</script>
<style scoped>
.animation-inprogress{
  transform-origin: center center !important;
}
.animation-over{
  transform-origin: left top !important;
}
</style>
